export default __webpack_public_path__ + "static/media/photo.44bde21f.svg";